import { Strings } from "@app/constants";
import { Icon } from "@iconify/react";
import { Stack, Typography, useTheme } from "@mui/material";

const Eligibility = () => {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        flexDirection: "column",
        gap: 2,
        p: 2,
        borderLeft: `10px solid ${theme.palette.primary.main}`,
        backgroundColor: theme.palette.primary.lighter,
        width: { sx: "90%", md: "80%" },
        borderRadius: 1,
      }}
    >
      <Stack
        flexDirection={"row"}
        alignItems={"center"}
        justifyContent={"start"}
        gap={1}
      >
        <Icon icon="mdi:information" color={theme.palette.primary.main} />
        <Typography sx={{ color: theme.palette.primary.main, fontWeight: 600 }}>
          {Strings.eligibilityCard.eligibilityCriteria}
        </Typography>
      </Stack>
      <Stack
        flexDirection={"row"}
        alignItems={"center"}
        justifyContent={"start"}
        px={{ sx: 1, md: 2 }}
        gap={{ sx: 5, md: 10 }}
        flexWrap={"wrap"}
      >
        <Stack flexDirection={"row"}>
          <Icon
            icon="material-symbols:done-rounded"
            color={theme.palette.grey[600]}
            fontSize={24}
          />
          <Typography
            sx={{ color: theme.palette.grey[600], fontWeight: 400 }}
            variant="subtitle1"
          >
            {Strings.eligibilityCard.serviceAvailableOnly}
          </Typography>
        </Stack>
        <Stack flexDirection={"row"}>
          <Icon
            icon="material-symbols:done-rounded"
            color={theme.palette.grey[600]}
            fontSize={24}
          />
          <Typography
            sx={{ color: theme.palette.grey[600], fontWeight: 400 }}
            variant="subtitle1"
          >
            {Strings.eligibilityCard.only1stOwnerCars}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export { Eligibility };
